import React from 'react';
import { useTranslation } from 'react-i18next';

import ParticipantOrderList from 'components/inputs/participantOrderList.component';
import { UserUmanforge } from '@umanforge/common';

interface EventManagerParticipantOrderTabProps {
  participantsList: UserUmanforge[];
  orderedParticipantIds: string[];
  setOrderedParticipantIds: React.Dispatch<React.SetStateAction<string[]>>;
  tableId?: string;
  backlogName: string;
  triggerParticipantUpdate: boolean;
  setTriggerParticipantUpdate: ( value: boolean ) => void;
}

const EventManagerParticipantOrderTab: React.FC<EventManagerParticipantOrderTabProps> = ( {
  participantsList,
  orderedParticipantIds,
  setOrderedParticipantIds,
  tableId,
  backlogName,
  triggerParticipantUpdate,
  setTriggerParticipantUpdate,
} ) => {
  const { t } = useTranslation();

  if ( participantsList.length === 0 ) {
    return null;
  }

  return (
    <div className="flex flex-col gap-4">
      <h3 className="font-bold mb-5">{ t( 'translation:participant_order' ) }</h3>
      <p className="mb-5">{ t( 'translation:participant_order_description' ) }</p>
      <ParticipantOrderList
        participants={participantsList}
        orderedIds={orderedParticipantIds}
        setOrderedIds={setOrderedParticipantIds}
        eventManagerId={tableId}
        backlogName={backlogName}
        triggerUpdate={triggerParticipantUpdate}
        onUpdateComplete={() => { return setTriggerParticipantUpdate( false ); }}
      />
    </div>
  );
};

export default EventManagerParticipantOrderTab;
